export default __webpack_public_path__ + "static/media/what-is-emc.fac23207.png";